"use client";

import ABTestPricingPage from "@/components/pages/ab-test/ab-test-pricing-page";
import ABTestPricePageProvider from "@/providers/ab-testing-providers/ab-test-pricing-page-provider";

const ABTestPricingPageWrapper = () => {
  return (
    <ABTestPricePageProvider>
      <ABTestPricingPage />
    </ABTestPricePageProvider>
  );
};

export default ABTestPricingPageWrapper;
